import React from "react";
import { AlertOctagon, RotateCcw } from "lucide-react";

// One broken screen must never take the whole console down with it.
export class ScreenBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Screen crashed", this.props.screen, error, info?.componentStack);
  }

  componentDidUpdate(prev) {
    if (prev.screen !== this.props.screen && this.state.error) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="rounded-xl border border-aegis-red/35 bg-aegis-red/5 p-8" data-testid="screen-error">
        <div className="flex items-center gap-3">
          <span className="grid h-10 w-10 place-items-center rounded-lg border border-aegis-red/35 bg-aegis-red/10 text-aegis-red">
            <AlertOctagon size={19} />
          </span>
          <div>
            <p className="font-heading text-[16px] text-slate-100">此画面渲染失败 · Screen failed to render</p>
            <p className="font-mono text-[11px] text-slate-400">
              {this.props.screen} · {String(this.state.error?.message || this.state.error).slice(0, 120)}
            </p>
          </div>
        </div>
        <p className="mt-4 max-w-2xl text-[13px] leading-relaxed text-slate-400">
          控制台的其余部分未受影响，你的会话与账本状态均已保留。可切换到其他画面继续工作，或重载本画面。
        </p>
        <button
          onClick={() => this.setState({ error: null })}
          data-testid="screen-error-retry"
          className="mt-5 inline-flex items-center gap-2 rounded-lg border border-edge raise px-4 py-2 text-sm text-slate-200 transition-colors hover:border-aegis-cyan/40 hover:text-aegis-cyan"
        >
          <RotateCcw size={14} /> 重新加载画面
        </button>
      </div>
    );
  }
}
